import { IssueType } from './IssueEntity'

export type TransactionType = IssueType | 'Warrant' | 'Convertible'

export const TransactionTypeShort = {
    'Rights issue': 'FE',
    'Non-cash issue': 'AE',
    IPO: 'IPO',
    'ABB Directed issue': 'ABB',
    'Directed issue': 'RE',
    'Guarantor fee issue': 'GE',
    Warrant: 'TO',
    Convertible: 'KV',
} as const
